<script setup lang="ts"></script>

<template>
  <section class="hero">
    <div class="hero__feature-title">
      Посещение профильных конференций CRE.ru
      <span class="hero__feature-title-highlight">бесплатно в течение год</span>
    </div>
    <div class="hero__feature-benefit">бесплатно в течение года</div>
    <div class="hero__feature-plus">+</div>
    <div class="hero__feature-extra">
      персональные скидки на все события медиахолдинга
    </div>
  </section>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.hero {
  height: 317px;
  background: #8497e0;
  color: #ffffff;
  @include font-medium;
  font-size: 32px;
  line-height: 130%;

  @media (max-width: $tablet-view) {
    font-size: 24px;
  }

  @media (max-width: $mobile-view) {
    font-size: 18px;
    height: 289px;
  }
}

.hero__feature-title {
  position: relative;
  top: 59px;
  left: 129px;
  width: fit-content;

  @media (max-width: $tablet-view) {
    top: 60px;
    left: 30px;
  }

  @media (max-width: $mobile-view) {
    top: 40px;
    left: 20px;
    width: calc(100% - 40px);
  }
}

.hero__feature-title-highlight {
  display: none;

  @media (max-width: $mobile-view) {
    display: inline;
  }
}

.hero__feature-benefit {
  position: relative;
  top: calc(101px - 24px * 1.3);
  left: 177px;
  width: fit-content;

  @media (max-width: $tablet-view) {
    top: 60px;
    left: 30px;
  }

  @media (max-width: $mobile-view) {
    display: none;
  }
}

.hero__feature-extra {
  position: relative;
  top: calc(175px - 32px * 1.3 * 2 - 146px * 1.3);
  left: 562px;
  max-width: 390px;

  @media (max-width: $tablet-view) {
    top: calc(175px - 32px * 1.3 * 2 - 146px * 1.3);
    left: calc(100% - 95px - 332px);
    max-width: 332px;
  }

  @media (max-width: $mobile-view) {
    top: -30px;
    left: calc(100% - 245px);
    max-width: 225px;
  }
}

.hero__feature-plus {
  position: relative;
  top: calc(69px - 32px * 1.3 * 2);
  left: 517px;
  width: fit-content;
  @include font-light;
  color: #f26628;
  font-size: 146px;
  line-height: 130%;

  @media (max-width: $tablet-view) {
    top: calc(69px - 32px * 1.3 * 2);
    left: calc(100% - 36px - 472px);
  }

  @media (max-width: $mobile-view) {
    top: 10px;
    left: calc(50% - 36px);
  }
}
</style>
